// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"AutoCompleteResult_suggestions__10wYg","name":"AutoCompleteResult_name__2X3dq"};